import React from 'react'
import { EMAILS } from 'shared-constants'
import { Flex } from 'components/Layout'
import Link from 'components/Link'
import { QA } from 'components/QA'
import { H4 } from 'components/Typography'
import { SPACE } from 'Theme'

export const FAQSection: React.FC<React.ComponentProps<typeof Flex>> = (
  props
) => (
  <Flex flexDirection="column" {...props}>
    <H4 as="h2" textAlign="center" mb={SPACE.PX_40}>
      FAQ
    </H4>
    <Flex flexDirection="column">
      <QA topBorder title="How does a consultation work?">
        <QA.Text>
          Expert consultations take place on Zoom video calls. Prior to the
          scheduled consultation, you will receive a link via email to join the
          video call where you will be met by your Expert. From there,
          you&apos;ll be able to show your space (via Zoom screen-share or over
          video), ask questions and get feedback/advice. There is not a set
          structure for how you utilize your time; consultations are meant to be
          collaborative and tailored to your needs and taste.
        </QA.Text>
      </QA>
      <QA title="How do I prepare for my consultation?">
        <QA.Text>
          Preparation can be as minimal or thorough as a client feels is
          necessary to accomplish their goals from the consultation. Generally,
          we suggest putting together a simple document or presentation that
          includes photos of the spaces you need help with and questions
          you&apos;d like answered. Some people also include inspiration images,
          furniture/decor being considered, or floor plans / drawings, etc.
        </QA.Text>
      </QA>
      <QA title="How do I show the Expert my space?">
        <QA.Text>
          Consultations happen over Zoom video calls, so you&apos;re able to
          show your space in real time using the camera on the device
          you&apos;re taking the call from. Many find it easier and more
          efficient to gather photos of their space into a document, which can
          be uploaded to your dashboard, to review during the consultation. You
          can also review additional imagery using Zoom&apos;s screen share
          feature
        </QA.Text>
      </QA>
      <QA title="How much can I accomplish in a consultation?">
        <QA.Text>
          Our clients are normally pleasantly surprised that they can get all
          their questions answered during a consultation and come away from it
          feeling enlightened, energized, confident in the next steps to take,
          and full of new ideas for their space. Our Experts design rooms all
          day every day, and so they can get into the zone of a new space very
          quickly and are naturally very efficient with their advice.
        </QA.Text>
      </QA>
      <QA title="What timezone are consultations displayed in?">
        <QA.Text>
          All consultation times are displayed in your local time zone, so even
          if an Expert lives in a different state, or even country, the times
          are always shown in the timezone you are visiting the site from.
        </QA.Text>
      </QA>
      <QA title="How does The Expert differ from e-design?">
        <QA.Text>
          The Expert is based around video consultations, during which the
          world&apos;s most trusted designers can offer guidance, support and
          advice to those embarking on a design project. E-design generally
          offers a less experienced designer that provides a specific set of
          deliverables, such as precise mock-ups, room design or layout. At The
          Expert, we believe that our discerning clients will derive more value
          from getting the hard questions answered by an Expert and feedback
          from a true tastemaker rather than receiving deliverables that may not
          be as closely aligned with their taste level.
        </QA.Text>
      </QA>
      <QA title="What type of product recommendations will I receive during my consultation?">
        <QA.Text>
          If you seek sourcing advice during your consultation, your Expert will
          send you personalized product recommendations suitable for your space,
          style, and budget. Their recommendations are not limited to The Expert
          and can be sourced from vendors and brands available through
          third-party websites, showrooms, stores, etc.
        </QA.Text>
      </QA>
      <QA title="What if none of the available dates/times work for me?">
        <QA.Text>
          Our Experts do their best to keep their availability up to date in
          their calendars, however, if you would like to book further in advance
          (i.e. upcoming months where an Expert hasn&apos;t added availability
          yet) or none of the listed times work for you, please email us at{' '}
          <Link
            href={`mailto:${EMAILS.CUSTOMER_SUPPORT}`}
            aria-label={`Contact to customer support ${EMAILS.CUSTOMER_SUPPORT}`}
          >
            {EMAILS.CUSTOMER_SUPPORT}
          </Link>{' '}
          and we will do our best to find an alternative time.
        </QA.Text>
      </QA>
    </Flex>
  </Flex>
)
